exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".options-popup[data-v-1524e64e]{position:absolute;z-index:1000;background-color:#fff;border:1px solid #ccc;box-shadow:0 2px 4px rgba(0,0,0,.1);max-height:150px;overflow-y:auto}.options-list[data-v-1524e64e]{padding:10px}.option-item[data-v-1524e64e]{padding:5px 10px;cursor:pointer}.option-item[data-v-1524e64e]:hover{background-color:#f0f0f0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1524e64e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/discuss/options-popup.vue
// module id = 1002
// module chunks = 0